import { useBoolean, useToast } from '@chakra-ui/react'
import * as crypto from 'crypto-js'
import dayjs from 'dayjs'
import fileDownload from 'js-file-download'
import { createContext, FC, useCallback, useMemo, useState } from 'react'
import { AiOutlineBarChart } from 'react-icons/ai'
import Swal from 'sweetalert2'
import { useImmer } from 'use-immer'

import { paramsAlertToSendMapping } from '@helper/alert/paramsAlertToSendMapping'
import { validateGroupName } from '@helper/alert/validateGroupName'
import { parseFollowupAlertData } from '@helper/grid/alert/followup'
import { formattedDate } from '@helper/kpi/sales/formattedDateKpi'
import alert from '@service/alert'

import { ILayoutFilter } from '@base/@types/components/Layout/Filters'
import {
  ITableHeader,
  ITableGridAction
} from '@base/@types/components/Layout/TableGrid'
import { ILayoutToolsAction } from '@base/@types/components/Layout/Tools'
import {
  IFollowUpAlertContext,
  IParamsToSend,
  QuantityPurchase,
  IParamsEdit,
  IDefaultDate,
  IUpdateParamsEdit,
  Pagination,
  IUpdateParams
} from '@base/@types/providers/Alert/FollowUpProvider'
import { followUpFilter } from '@base/variables/filters/alerts/followUpFilter'
import { followUpRequest } from '@base/variables/filters/alerts/followUpRequest'
import FollowUplertHeader from '@base/variables/headers/alert/follow-up'
export enum DaysQuantity {
  year = 365
}
const FollowUpAlertProvider: FC = ({ children }) => {
  const toast = useToast()

  const [loading, setLoading] = useState(false)
  const [loadingModalHistoric, setLoadingModalHistoric] = useState(false)
  const [showingModalHistoric, setShowingModalHistoric] = useState(false)
  const [loadingModalHistoricExport, setLoadingModalHistoricExport] =
    useState(false)

  const [currentyDate, setCurrentyDate] = useState({} as IDefaultDate)

  const [selecteds, setSelecteds] = useImmer([] as any)
  const [_selected, setSelectedOne] = useState(0)
  const [filters, setFilters] = useBoolean(true)
  const [atencaoCheck, setAtencaoCheck] = useState(true)
  const [noprazoCheck, setNoprazoCheck] = useState(true)
  const [atrasadoCheck, setAtrasadoCheck] = useState(true)
  const filtersList: ILayoutFilter[] = followUpFilter
  const [filename] = useState('Alertas FollowUp Compras')

  const [data, updateData] = useImmer<any[]>([])
  const [dataHistoric, updateDataHistoric] = useImmer<any[]>([])
  const [loadingEdit, setLoadingEdit] = useState(false)
  const [filterEdit] = useState({
    fornecedores: []
  })
  const [paramsEdit, updateEditParams] = useImmer<IParamsEdit>({
    fornecedor: [],
    date: dayjs(new Date()).format('YYYY-MM-DD'),
    coment: ''
  })
  const [params, updateParams] = useImmer<any>(followUpRequest)
  const [quantity, updateQuantity] = useState<QuantityPurchase>({
    total: 0,
    compra: 0,
    recebimento: 0
  })
  const [pagination, updatePagination] = useImmer<Pagination>({
    actualPage: 0,
    rows: 0,
    totalPages: 0,
    totalRows: 0,
    skip: 0
  })
  const [headers, updateHeaders] = useImmer<ITableHeader[]>(FollowUplertHeader)
  const [typeGrid, setTypeGrid] = useState(1)

  const defaultDate = useMemo(() => {
    const dateNow = new Date()
    const dateEnd = dateNow.setDate(dateNow.getDate() - DaysQuantity.year)
    const initialDate = dayjs(dateEnd).format('YYYY-MM-DD')
    const finalDate = dayjs(new Date()).format('YYYY-MM-DD')

    setCurrentyDate({
      initialDate,
      finalDate
    })

    return {
      initialDate,
      finalDate
    } as IDefaultDate
  }, [])

  const [paramsToSend, setParamsToSend] = useState<IParamsToSend>(() => {
    const paramsFormatted = { ...followUpRequest }

    paramsFormatted.periodo = {
      agrupar: paramsFormatted.periodo.agrupar,
      inicio: formattedDate(defaultDate.initialDate),
      final: formattedDate(defaultDate.finalDate)
    }

    return paramsFormatted
  })

  const handleSelect = useCallback(
    async (index: any) => {
      const followUp = index['general-id']

      if (!selecteds.includes(followUp)) {
        setSelecteds([...selecteds, followUp])
      } else {
        setSelecteds(selecteds.filter((prop: any) => prop !== followUp))
      }
    },
    [setSelecteds, selecteds]
  )

  const handleupdateQuantity = useCallback(
    async (data: any) => {
      const obj = {
        total: data.length,
        compra: data.filter((x: any) => x.alertaCompra).length,
        recebimento: data.filter((x: any) => x.receberAlerta).length
      }
      updateQuantity(obj)
    },
    [updateQuantity]
  )

  const clearAllFilters = () => {
    const paramsFormatted = { ...followUpRequest }

    paramsFormatted.periodo = {
      agrupar: paramsFormatted.periodo.agrupar,
      inicio: formattedDate(defaultDate.initialDate),
      final: formattedDate(defaultDate.finalDate)
    }

    updateParams({
      ...params,
      empresaIds: false,
      empresaSelectIds: [],
      centroCdLojaIds: false,
      centroCdLojaSelectIds: [],
      gerenteCategoriaIds: false,
      gerenteCategoriaSelectIds: [],
      gerenteProdutoIds: false,
      gerenteProdutoSelectIds: [],
      mundoIds: false,
      mundoSelectIds: [],
      categoriaCompactaIds: false,
      categoriaCompactaSelectIds: [],
      fornecedorSelectIds: [],
      produtoSelectIds: [],
      periodoIds: false
    })

    setParamsToSend(paramsFormatted)

    setCurrentyDate({
      initialDate: defaultDate.initialDate,
      finalDate: defaultDate.finalDate
    })

    if (localStorage.getItem('alertFollowUpParams')) {
      localStorage.setItem(
        'alertFollowUpParams',
        crypto.AES.encrypt(
          JSON.stringify({
            ...params,
            empresaIds: false,
            empresaSelectIds: [],
            centroCdLojaIds: false,
            centroCdLojaSelectIds: [],
            gerenteCategoriaIds: false,
            gerenteCategoriaSelectIds: [],
            gerenteProdutoIds: false,
            gerenteProdutoSelectIds: [],
            mundoIds: false,
            mundoSelectIds: [],
            categoriaCompactaIds: false,
            categoriaCompactaSelectIds: [],
            fornecedorSelectIds: [],
            periodoIds: false
          }),
          'CHAVE'
        ).toString()
      )
    }
    if (localStorage.getItem('alertFollowUpParamsRequest')) {
      localStorage.setItem(
        'alertFollowUpParamsRequest',
        crypto.AES.encrypt(JSON.stringify(paramsFormatted), 'CHAVE').toString()
      )
    }
  }

  const handleUpdateParams = ({ name, value }: IUpdateParams) => {
    updateParams((draft: { [x: string]: string }) => {
      draft[name] = value
    })

    name === 'initialDate' &&
      setCurrentyDate({ initialDate: value, finalDate: currentyDate.finalDate })

    name === 'finalDate' &&
      setCurrentyDate({
        finalDate: value,
        initialDate: currentyDate.initialDate
      })

    const paramsToSendFormatted = paramsAlertToSendMapping({
      name,
      value,
      compareName: name,
      paramsToSend,
      fieldName: validateGroupName(name)
    })

    setParamsToSend(paramsToSendFormatted)
    if (localStorage.getItem('alertFollowUpParams')) {
      const newParams: IParamsToSend[] = JSON.parse(
        crypto.AES.decrypt(
          localStorage.getItem('alertFollowUpParams'),
          'CHAVE'
        ).toString(crypto.enc.Utf8) || ''
      )

      localStorage.setItem(
        'alertFollowUpParams',
        crypto.AES.encrypt(
          JSON.stringify({ ...newParams, [name]: value }),
          'CHAVE'
        ).toString()
      )
    }
    if (localStorage.getItem('alertFollowUpParamsRequest')) {
      localStorage.setItem(
        'alertFollowUpParamsRequest',
        crypto.AES.encrypt(
          JSON.stringify(paramsToSendFormatted),
          'CHAVE'
        ).toString()
      )
    }
  }

  const handleLocalParams = useCallback(async () => {
    if (localStorage.getItem('alertFollowUpParams')) {
      const newParams = JSON.parse(
        crypto.AES.decrypt(
          localStorage.getItem('alertFollowUpParams'),
          'CHAVE'
        ).toString(crypto.enc.Utf8) || ''
      )
      updateParams(newParams)
    } else {
      localStorage.setItem(
        'alertFollowUpParams',
        crypto.AES.encrypt(JSON.stringify(params), 'CHAVE').toString()
      )
    }
    if (localStorage.getItem('alertFollowUpParamsRequest')) {
      const newParams = JSON.parse(
        crypto.AES.decrypt(
          localStorage.getItem('alertFollowUpParamsRequest'),
          'CHAVE'
        ).toString(crypto.enc.Utf8) || ''
      )
      setParamsToSend(newParams)
    } else {
      localStorage.setItem(
        'alertFollowUpParamsRequest',
        crypto.AES.encrypt(JSON.stringify(paramsToSend), 'CHAVE').toString()
      )
    }
  }, [updateParams, setParamsToSend, params, paramsToSend])

  const toggleColumn = useCallback(
    (index: number, column: number) => {
      updateHeaders(draft => {
        draft[index].columns![column].show = !draft[index].columns![column].show
      })
    },
    [updateHeaders]
  )
  const actions = useMemo<ILayoutToolsAction[]>(() => {
    return [
      {
        type: 'export',
        exports: [
          {
            type: 'excel',
            entity: 'alertFollowUp',
            data,
            headers
          },
          {
            type: 'excel',
            entity: 'alertFollowUpComment',
            data,
            headers
          }
        ]
      },
      {
        type: 'followUploadComment'
      },
      {
        type: 'followUpRevisaoUpload'
      }
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handlePageChange = useCallback(
    async (page: number) => {
      setLoading(true)

      localStorage.setItem(
        '@AlertPurchaseParamsToSend:',
        JSON.stringify(paramsToSend)
      )

      alert
        .getPurschaseData(paramsToSend, page)
        .then(({ data: { data, pagination } }) => {
          updateData(draft => {
            return draft.filter(item => item.status === 99).concat(data)
          })
          handleupdateQuantity(data)

          updatePagination(pagination)
          setLoading(false)
        })
        .catch(() => updateData([]))
      setLoading(false)
    },
    [paramsToSend, updateData, updatePagination, handleupdateQuantity]
  )
  const getCenters = useCallback(async () => {
    // Fornecedor agora é filtro lateral genérico — nada a carregar separadamente
  }, [])

  const exportData = useCallback(async () => {
    const params = {
      ...paramsToSend,
      statusPedido: [2, 3, 4]
    }
    Swal.fire({
      title: 'Exporta dados!',
      html: 'Aguarde um momento<b></b>.',
      timerProgressBar: true,
      timer: 99999,
      didOpen: () => {
        Swal.showLoading()
      }
    })
    try {
      const { data: res } = await alert.postExportAlertFollowUp(params)
      fileDownload(res, filename + '.csv', 'text/csv;charset=utf-8')
      Swal.close()
    } catch (error: any) {
      const { data } = error.response
      const message =
        data.response?.status === 400
          ? data.response?.data?.data[0].message
          : 'Ocorreu um problema interno. Tente novamente mais tarde'
      toast({
        title: 'Atenção.',
        description: message,
        status: 'warning',
        duration: 2000,
        isClosable: true
      })
    }
  }, [toast, filename, paramsToSend])

  const getDatas = useCallback(async () => {
    setLoading(true)
    localStorage.setItem(
      '@AlertPurchaseParamsToSend:',
      crypto.AES.encrypt(JSON.stringify(paramsToSend), 'CHAVE').toString()
    )

    const params = {
      ...paramsToSend,
      statusPedido: [2, 3, 4]
    }
    alert
      .getAlertFollowUp(params)
      .then(({ data: { data } }) => {
        setSelecteds([])
        updateData(draft => {
          return draft.filter(item => item.status === 99).concat(data)
        })
        setLoading(false)
        setFilters.toggle()
      })
      .catch(() => {
        updateData([])
        setLoading(false)
      })
  }, [paramsToSend, setSelecteds, updateData, setFilters])

  const exportHistoricComment = useCallback(async () => {
    localStorage.setItem(
      '@AlertPurchaseParamsToSend:',
      crypto.AES.encrypt(JSON.stringify(paramsToSend), 'CHAVE').toString()
    )

    const params = {
      ...paramsToSend,
      statusPedido: [2, 3, 4]
    }

    alert
      .getAlertFollowUpExportComment(params)
      .then(({ data }) => {
        fileDownload(
          data,
          'Historico comentarios - follow up ' +
            dayjs(new Date()).format('DD/MM/YYYY ') +
            '.csv'
        )
        toast({
          title: 'Sucesso.',
          description: 'Arquivo exportado com sucesso',
          status: 'success',
          duration: 3000,
          isClosable: true
        })
        setLoadingModalHistoricExport(false)
      })
      .catch(({ response: { data } }) => {
        const message =
          data.response?.status === 400
            ? data.response?.data?.data[0].message
            : 'Ocorreu um problema interno. Tente novamente mais tarde'
        toast({
          title: 'Atenção.',
          description: message,
          status: 'warning',
          duration: 3000,
          isClosable: true
        })
      })
  }, [paramsToSend, toast])
  const getParameterDatas = useCallback(
    async (_paramsFilter: any[]) => {
      getDatas()
    },
    [getDatas]
  )

  const getData = useCallback(async () => {
    getDatas()
  }, [getDatas])

  const getHistoric = useCallback(
    async (id: number) => {
      setLoadingModalHistoric(true)
      setShowingModalHistoric(true)
      const objFindById = data.find(objeto => objeto.id === id)
      alert
        .getComments(
          objFindById.documentoId,
          objFindById.lojaId,
          objFindById.produtoId
        )
        .then(({ data: { data } }) => {
          updateDataHistoric(data)
          setLoadingModalHistoric(false)
        })
        .catch(() => {
          updateDataHistoric([])
          setLoadingModalHistoric(false)
        })
    },
    [data, updateDataHistoric]
  )

  const exportModalHistoric = useCallback(
    async (id: number) => {
      setLoadingModalHistoricExport(true)
      const objFindById = data.find(objeto => objeto.id === id)
      alert
        .getCommentsExport(
          objFindById.documentoId,
          objFindById.lojaId,
          objFindById.produtoId
        )
        .then(({ data }) => {
          fileDownload(
            data,
            'Historico comentarios - follow up ' +
              dayjs(new Date()).format('DD/MM/YYYY ') +
              '.csv'
          )
          toast({
            title: 'Sucesso.',
            description: 'Arquivo exportado com sucesso',
            status: 'success',
            duration: 3000,
            isClosable: true
          })
          setLoadingModalHistoricExport(false)
        })
        .catch(({ response: { data } }) => {
          const message =
            data.response?.status === 400
              ? data.response?.data?.data[0].message
              : 'Ocorreu um problema interno. Tente novamente mais tarde'
          toast({
            title: 'Atenção.',
            description: message,
            status: 'warning',
            duration: 3000,
            isClosable: true
          })
          setLoadingModalHistoricExport(false)
        })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data, updateDataHistoric]
  )
  const handleUpdateEditParams = useCallback(
    async ({ name, value }: IUpdateParamsEdit) => {
      updateEditParams(draft => {
        draft[name] = value
      })
      if (name === 'fornecedor') {
        getParameterDatas(value)
      }
    },
    [updateEditParams, getParameterDatas]
  )

  const deselectSelecteds = useCallback(async () => {
    updateData([])
  }, [updateData])

  const selectAllSupplys = useCallback(async () => {
    // Fornecedor agora é filtro lateral
  }, [])

  const handledTypeGrid = (value: number) => {
    setTypeGrid(value)
  }

  const handleSelectAllFilter = useCallback(
    async (filter: string | number) => {
      const newData = data.filter((x: any) => x.documentoId === filter)
      for (const filter of newData) {
        if (!selecteds.includes(filter.id)) {
          setSelecteds((selecteds: any) => [...selecteds, filter.id])
        } else {
          setSelecteds((selecteds: any) =>
            selecteds.filter((prop: any) => prop !== filter.id)
          )
        }
      }
    },
    [data, setSelecteds, selecteds]
  )
  const tableInteraction = useMemo<ITableGridAction[]>(() => {
    return [
      {
        type: 'checkbox',
        icon: <AiOutlineBarChart />,
        onChange: handleSelect,
        selecteds: selecteds,
        isMulti: true
      },
      {
        type: 'checkbox-filter',
        icon: <AiOutlineBarChart />,
        onChange: handleSelectAllFilter,
        selecteds: selecteds,
        isMulti: true
      }
    ]
  }, [selecteds, handleSelect, handleSelectAllFilter])

  const sendComments = useCallback(async () => {
    try {
      const objUpdate: { documentoId: any; produtoId: any; lojaId: any }[] = []
      selecteds.forEach((element: any) => {
        const dataFind = data.find(objeto => objeto.id === element)
        objUpdate.push({
          documentoId: dataFind.documentoId,
          produtoId: dataFind.produtoId,
          lojaId: dataFind.lojaId
        })
      })
      await alert.postComment({
        ordensCompra: objUpdate,
        dataSolucao: paramsEdit.date,
        comentario: paramsEdit.coment
      })
      await getDatas()
      handleUpdateEditParams({
        name: 'coment',
        value: ''
      })
      toast({
        title: 'Sucesso',
        description: 'Comentário adicionado com sucesso',
        status: 'success',
        duration: 2000,
        isClosable: true
      })
      setLoading(false)
      setSelectedOne(0)
    } catch (error: any) {}
  }, [
    data,
    selecteds,
    paramsEdit.date,
    paramsEdit.coment,
    getDatas,
    handleUpdateEditParams,
    toast
  ])

  const closeModal = useCallback(async () => {
    setShowingModalHistoric(false)
  }, [setShowingModalHistoric])

  const handleCheck = useCallback(
    async (state: boolean, prop: string | number) => {
      switch (prop) {
        case 1:
          return setAtencaoCheck(state)

        case 2:
          return setNoprazoCheck(state)

        case 3:
          return setAtrasadoCheck(state)

        default:
          return null
      }
    },
    []
  )

  const postUpload = useCallback(
    async (event: any) => {
      setLoading(true)

      alert
        .uploadComment({
          file: event.target.files[0]
        })
        .then(() => {
          getData()
          toast({
            title: 'Sucesso',
            description: 'Alterações realizadas com Sucesso',
            status: 'success',
            duration: 2000,
            isClosable: true
          })
          setLoading(false)
        })
        .catch(response => {
          let htmlLines = ''
          for (let aux = 0; aux < response.response.data.data.length; aux++) {
            htmlLines += '<li>' + response.response.data.data[aux] + '</>'
          }
          Swal.fire({
            title: '<strong>Ops, houver um error</u></strong>',
            icon: 'error',
            html: 'Verificar os erros abaixo, ' + htmlLines,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false
          })

          setLoading(false)
        })
    },
    [toast, setLoading, getData]
  )

  return (
    <FollowUpAlertContext.Provider
      value={{
        loading,

        filtersList,
        pagination,

        data: parseFollowupAlertData(data),
        dataOne: parseFollowupAlertData(
          data.filter((data: any) => data.statusPedido === 2)
        ),
        dataTwo: parseFollowupAlertData(
          data.filter((data: any) => data.statusPedido === 3)
        ),
        dataTree: parseFollowupAlertData(
          data.filter((data: any) => data.statusPedido === 4)
        ),
        actions,
        params,
        handlePageChange,
        exportData,
        quantity,
        loadingEdit,
        atencaoCheck,
        noprazoCheck,
        handleCheck,
        atrasadoCheck,
        setAtencaoCheck,
        setNoprazoCheck,
        setAtrasadoCheck,
        filterEdit,
        tableInteraction,
        handleUpdateEditParams,
        sendComments,
        paramsEdit,
        selectAllSupplys,
        headers,
        typeGrid,
        deselectSelecteds,
        handledTypeGrid,
        defaultDate,
        currentyDate,
        handleSelect,
        getCenters,
        getDatas,
        filename,
        filters,
        dataHistoric,
        getHistoric,
        handleSelectAllFilter,
        loadingModalHistoric,
        handleLocalParams,

        clearAllFilters,
        toggleColumn,
        selecteds,
        handleUpdateParams,
        showingModalHistoric,
        closeModal,
        getData,
        loadingModalHistoricExport,
        exportModalHistoric,
        exportHistoricComment,
        setFilters,
        postUpload
      }}
    >
      {children}
    </FollowUpAlertContext.Provider>
  )
}

export default FollowUpAlertProvider
export const FollowUpAlertContext = createContext<IFollowUpAlertContext>(
  {} as IFollowUpAlertContext
)
